var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown)?_c('div',{directives:[{name:"portal",rawName:"v-portal"}],staticClass:"black-bg",on:{"click":_vm.close}},[_c('div',{ref:"clo",staticClass:"close"}),_c('img',{ref:"src",staticClass:"bg-img",style:({'margin-top':_vm.gogo}),attrs:{"src":_vm.src,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }